import { useState } from 'react';

export const useMockState = () => {
  const [isFavorite, setIsFavorite] = useState(false);

  const toggleMockFavorite = () => {
    setIsFavorite((prev) => !prev);
    return !isFavorite;
  };

  const getMockFavoriteState = () => isFavorite;

  return {
    isFavorite,
    toggleMockFavorite,
    getMockFavoriteState,
  };
};
